module.exports = __webpack_public_path__ + "static/media/girluplogo.ba729d31.jpg";